export default __webpack_public_path__ + "static/media/ic_wbnb_24.0d111c66.svg";